import colors from "../base/colors";
import pxToRem from "../functions/pxToRem";

const tonalBg = (colors.background as { tonal?: string }).tonal || "rgba(0, 0, 0, 0.04)";
const tonalHover = (colors.background as { tonalHover?: string }).tonalHover || "rgba(0, 0, 0, 0.07)";

/** Fluent subtle icon button: faint idle fill, stronger on hover, 4px corners. */
const iconButton = {
  styleOverrides: {
    root: {
      backgroundColor: tonalBg,
      borderRadius: pxToRem(4),
      transition:
        "background-color 0.15s cubic-bezier(0.33, 0, 0.67, 1), color 0.15s cubic-bezier(0.33, 0, 0.67, 1)",

      "&:hover": {
        backgroundColor: tonalHover,
      },

      "&.Mui-disabled": {
        backgroundColor: colors.grey[100],
      },
    },
  },
};

export default iconButton;
